<template>
  <div class="ed-table__footer">
    <span class="ed-table__footer-item" v-show="optionElmtByPage">{{ footerPaginationLabel1 }}
      <select name="elmt_nbr" id="tableElmtNumber" v-model="actualElmtsByPage" @change="newElmtNumber('tableElmtNumber')">
        <option  v-for="elmt in optionElmtByPage" :value="elmt">{{ elmt }}</option>
      </select>
      {{ footerPaginationLabel2 }}
    </span>
    <span class="ed-table__footer-item ef-hidden-md" v-if="totalElmtsFooter">
      {{ totalElmtsFooter }} {{ footerTotalLabel }}
    </span>
    <span class="ed-table__footer-item" v-show="totalPages">
      <default-button class="small ed-table-navigation-btn" @click.native="firstPage" :disabled="hasPrevious"><span class="icon-page-first"></span></default-button>
      <default-button class="small ed-table-navigation-btn" @click.native="prevPage" :disabled="hasPrevious"><span class="icon-page-previous"></span></default-button>
       {{ actualCurrentPage }} {{ footerPaginationSeparator }} {{ totalPages }}
       <default-button class="small ed-table-navigation-btn" @click.native="nextPage" :disabled="hasNext"><span class="icon-page-next"></span></default-button>
       <default-button class="small ed-table-navigation-btn" @click.native="lastPage" :disabled="hasNext"><span class="icon-page-last"></span></default-button>
    </span>
    <span class="ed-table__footer-item" v-show="hideShowColumns">
      <span @click="displayColumnModal" class="ed-table__footer-link">{{ footerModalOpen }}</span>
    </span>

    <transition name="fade">
      <div class="ed-modal ed-modal--column-modal" v-if="openModal">
        <div class="ed-modal__mask" @click="closeModal"></div>
        <div class="ed-modal__container ed-modal__container--small">
          <div class="ed-modal__header">

            <div class="ed-pull-right-layout">
              <div class="ed-pull-right-layout__first-elmt">
                {{ footerModalTitle }}
              </div>
              <div class="ed-pull-right-layout__second-elmt">
                <button @click="closeModal" class="ed-modal__header-close icon-close"></button>
              </div>
            </div>
          </div>
          <div class="ed-modal__body">
            <div class="ed-modal__part" v-for="head in header">
              <checkbox :id="'column' + head.reference" :value="head.reference" @check="showColumn" @uncheck="hideColumn" :checked="head.show">{{ head.name }}</checkbox>
            </div>
          </div>
          <div class="ed-modal__footer">
            <div class="ed-pull-right-layout">
              <div class="ed-pull-right-layout__first-elmt"></div>
              <div class="ed-pull-right-layout__second-elmt">
                <button @click="closeModal" class="ed-btn-default ed-btn-default--inverse">{{ footerModalAction }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>

  export default {
    name: 'edTableFooter',
    data() {
      return {
        actualCurrentPage: this.currentParentPage,
        actualElmtsByPage: this.elmtsByPage,
        openModal: false,
      };
    },
    props: {
      footerTotalLabel: String,
      footerModalOpen: String,
      footerModalTitle: String,
      footerModalAction: String,
      footerPaginationLabel1: String,
      footerPaginationLabel2: String,
      footerPaginationSeparator: String,
      totalPages: Number,
      totalElmtsFooter: Number,
      header: Array,
      currentParentPage: Number,
      optionElmtByPage: Array,
      elmtsByPage: String,
      hideShowColumns: Boolean,
    },
    computed: {
      hasNext() {
        if (this.actualCurrentPage === this.totalPages) {
          return true;
        }
        return false;
      },
      hasPrevious() {
        if (this.actualCurrentPage === 1) {
          return true;
        }
        return false;
      },
    },

    watch: {
      currentParentPage() {
        this.actualCurrentPage = this.currentParentPage;
         this.$emit('pageChange', this.actualCurrentPage);
      },
      totalPages() {
        if (this.totalPages < this.currentParentPage) {
          this.currentParentPage = this.totalPages;
        }
      },
    },

    methods: {
      showColumn(reference) {
        /* Put all targeted cells on a array */
        const allCells = Array.prototype.slice.call(document.getElementsByTagName('th'));
        for (let index = 0; index < allCells.length; index += 1) {
          if (allCells[index].getAttribute('data-columnName') === reference) {
            allCells[index].style.width = '100px';
          }
        }
        Array.prototype.push.apply(allCells, Array.prototype.slice.call(document.getElementsByTagName('td')));
        /* Show the ones that have a corresponding column-name data */
        for (let index = 0; index < allCells.length; index += 1) {
          if (allCells[index].getAttribute('data-columnName') === reference) {
            allCells[index].style.display = 'table-cell';
          }
        }
        const headerIndex = this.header.findIndex(elmt => elmt.reference === reference);
        this.header[headerIndex].show = true;
        this.$emit('columnChange');
      },

      hideColumn(reference) {
        /* Put all targeted cells on arrays */
        const allHeaders = [];
        for (let index = 0; index < document.getElementsByTagName('th').length; index += 1) {
          if (document.getElementsByTagName('th')[index].hasAttribute('data-columnname')) {
            allHeaders.push(document.getElementsByTagName('th')[index]);
          }
        }
        const allCells = allHeaders.concat(Array.prototype.slice.call(document.getElementsByTagName('td')));
        /* Hide the ones that have a corresponding column-name data */
        for (let index = 0; index < allCells.length; index += 1) {
          if (allCells[index].getAttribute('data-columnName') === reference) {
            allCells[index].style.display = 'none';
          }
        }
        /* Fix width of headers when the event is over */
        for (let index = 0; index < allHeaders.length; index += 1) {
          allHeaders[index].style.width = `${allHeaders[index].offsetWidth -
            (parseInt(window.getComputedStyle(allHeaders[index]).paddingLeft, 10) +
             parseInt(window.getComputedStyle(allHeaders[index]).paddingRight, 10))}px`;
        }
        const headerIndex = this.header.findIndex(elmt => elmt.reference === reference);
        this.header[headerIndex].show = false;
        this.$emit('columnChange');
      },

      nextPage() {
        /* Set the page number 1 digit above if it is not equal to the total number of pages */
        if (this.actualCurrentPage + 1 <= this.totalPages) {
          this.actualCurrentPage = this.actualCurrentPage + 1;
        }
        /* Triggers the parent action that will update the current page number */
        this.$emit('pageChange', this.actualCurrentPage);
      },

      prevPage() {
        /* Set the page number 1 digit below if it is not equal to 1 */
        if (this.actualCurrentPage - 1 >= 1) {
          this.actualCurrentPage = this.actualCurrentPage - 1;
        }
        /* Triggers the parent action that will update the current page number */
        this.$emit('pageChange', this.actualCurrentPage);
      },

      firstPage() {
        /* Set the page number to 1 */
        this.actualCurrentPage = 1;
        /* Triggers the parent action that will update the current page number */
        this.$emit('pageChange', this.actualCurrentPage);
      },

      lastPage() {
        /* Set the page number 1 digit below if it is not equal to 1 */
        this.actualCurrentPage = this.totalPages;
        /* Triggers the parent action that will update the current page number */
        this.$emit('pageChange', this.actualCurrentPage);
      },

      newElmtNumber(id) {
        this.$emit('elementsNumberChange', document.getElementById(id).value);
      },

      displayColumnModal() {
        this.openModal = true;
      },

      closeModal() {
        this.openModal = false;
      },

    },
  };
</script>



// WEBPACK FOOTER //
// edTableFooter.vue?70592755